import './selectStakeholder.css';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import TrashIcon from '../../../images/TrashIcon.png';
import { MDBSwitch } from 'mdb-react-ui-kit';
import { NOT_MAPPED, MAPPED, NO_DATA_AVAILABLE, PLANT_URN } from '../../../common/constants';
import { DialogContent, Dialog, DialogActions, Button, Tooltip } from '@mui/material';
import { getStakeholderType, getAllState, getAllDistrict, saveStakeHolderMapping, validation_check_mapping, gettoStakeholderType, getSelectedStakeholderDetails, getAllStakeHolderDetails, DeleteDeactiveEditTransporterMapping, checkMappingExists } from './stakeholderMappingApi';
import { ParseFloat, lastFiveDigitsComparator } from '../../../common/commonFunction';
import { ViewOtherMappedStakeholder } from './viewOtherMappedStakeholder';
import { PROD } from '../../../common/constants';
import { Card, CardContent, IconButton, Container, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { titleCase } from '../../../common/commonFunction';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import { AddIcon, ProceedIcon, RemoveRedEyeIcon } from '../../../common/icons';

function SelectStakeholder() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [details, setDetails] = useState({
    resourceState: '',
    resourceDistrict: '',
    RescChooseStakeholder: ' ',
    RescChoosetoStakeholder: ' '
  });
  const [errorMessage, setErrorMessage] = useState({
    stateError: '',
    districtError: '',
    choosestakeholderError: '',
    chooseTostakeholderError: '',
  });
  const [filterTable, setFilterTable] = useState({
    urnNumber: '',
    name: '',
  });
  const [updatedDetails, setUpdatedDetails] = useState({
    UpdatedTargetName: '',
    UpdatedTargetUrn: '',
    mappedItemId: '',
    growerUrn: '',
    inBetweenDistance: '',
    deactiveid: '',
    deleteid: '',
    deactivestatus: '',
    sourcestakeholderType: '',
    sourceGrowerLandId: ''
  });
  let [showStakeHolderDetails, setStakeHolderDetails] = useState(false);
  const [mappedToBeStakeholder, setMappedToBeStakeholder] = useState();
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [chooseUser, setchooseUser] = useState([]);
  const [chooseState, setchooseState] = useState([]);
  const [chooseDistrict, setchooseDistrict] = useState([]);
  const [chooseFromUser, setchooseFromUser] = useState([]);
  let [showData, setshowData] = useState(false);
  let [showLLEName, setshowLLEName] = useState(false);
  const userlog = useRef(true);
  const statelog = useRef(true);
  const [selectedStakeHolderDetails, setSelectedStakeHolderDetails] = useState([]);
  const [saveMappingData, setSaveMappingData] = useState();
  const [filteredResults, setFilteredResults] = useState([]);
  const [saveMultiMappingData, setSaveMultiMappingData] = useState([]);
  let [showStateDistrictInput, setShowStateDistrictInput] = useState(false);
  const [mappedModalOpen, setMappedModalOpen] = useState(false);
  const handleMappedModalOpen = () => setMappedModalOpen(true);
  const handleMappedModalClose = () => setMappedModalOpen(false);
  const [linkedtoArray, setLinkedtoArray] = useState([]);
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [logConfirmModalOpenSave, setLogConfirmModalOpenSave] = useState(false);
  const handleConfirmLogModalOpenSave = () => setLogConfirmModalOpenSave(true);
  const handleConfirmLogModalCloseSave = () => setLogConfirmModalOpenSave(false);
  const [mappingValidationCheck, setMappingValidationCheck] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [saveData, setSaveData] = useState();
  const [validationlogOpen, setValidationlogOpen] = useState(false);
  const handleValidationModalOpen = () => setValidationlogOpen(true);
  const handleValidationModalClose = () => setValidationlogOpen(false);
  const [finaldata, setFinalData] = useState();
  const [failedMappingArr, setFailedMappingArr] = useState();
  const [successMappingArr, setSuccessMappingArr] = useState();

  const [selectedMappingRows, setSelectedMappingRows] = useState([]);
  const [commonMappedStakeholder, setCommonMappedStakeholder] = useState('');
  const [commonMappedStakeholderList, setCommonMappedStakeholderList] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);

  useEffect(() => {
    if (userlog.current) {
      userlog.current = false;
      getStakeholderType(setchooseUser)
    }
  }, [userlog]);
  useEffect(() => {
    if (statelog.current) {
      statelog.current = false;
      getAllState(setchooseState)
    }
  }, [statelog]);
  const [showArrGrower, setshowArrGrower] = useState([]);
  useEffect(() => {
    if (saveMappingData) {
      if (saveMappingData.description) {
        if (saveMappingData?.status === "SUCCESS") {
          toast.success(saveMappingData?.description)
          // navigate('./selectStakeHolder');
        }
        else {
          toast.error(saveMappingData?.description)
        }
        setUpdatedDetails('')
        setshowArrGrower([])
        setshowData(false)
        setFilterTable(" ")
        setStakeHolderDetails(false)
        setshowLLEName(false)
        setSaveMultiMappingData([]);       
        setSelectionModel([]);
        setSelectedMappingRows([]);
        setCommonMappedStakeholder('');
        getAllStakeHolderDetails(setMappedToBeStakeholder, details);
      }
    }
  }, [saveMappingData]);
  useEffect(() => {
    if (mappedToBeStakeholder) {
      if (mappedToBeStakeholder.length > 0) {

        let showArr = []
        mappedToBeStakeholder?.map((arritem) => {
          arritem?.landDetailsList?.map((landitem) =>
            showArr.push({
              name: arritem?.stakeholderName,
              urn: arritem?.sourceUrn,
              landname: landitem?.landName,
              qtybamboo: arritem?.bambooQty,
              distance: landitem?.distance,
              targetStakeholderType: landitem?.targetStakeholderType,
              growerType: arritem?.growerType,
              targetStakeholderUrn: landitem?.targetStakeholderUrn,
              targetStakeholderName: landitem?.landMappedWith,
              sourceGrowerLandId: landitem?.id,
              sourceGrowerTableId: landitem?.tableId,
              llename: landitem?.landMappedWith,
              mapped: landitem?.landMapped,
              isActive: landitem?.isActive,
              isDeleteDeactivate: landitem?.sendForDeleteDeactivate,
              targetState: arritem?.state,
              targetDistrict: arritem?.district
            })
          )
          if (!(arritem.landDetailsList)) {
            showArr.push({
              name: arritem?.stakeholderName,
              urn: arritem?.sourceUrn,
              landname: '',
              qtybamboo: '',
              distance: arritem?.distance,
              targetStakeholderType: arritem?.targetStakeholderType,
              growerType: arritem?.growerType,
              targetStakeholderUrn: arritem?.targetUrn,
              targetStakeholderName: arritem?.targetStakeholderName,
              sourceGrowerLandId: arritem?.tableId,
              sourceId: arritem?.id,
              sourceGrowerTableId: arritem?.tableId,
              llename: arritem?.targetStakeholderName,
              mapped: arritem?.mapped,
              isActive: arritem?.isActive,
              isDeleteDeactivate: arritem?.isDeleteDeactivate,
            })
          }
        })

        setshowArrGrower(showArr)
        setStakeHolderDetails(true)
        if (showArr.length > 0) {
          const firstRow = showArr[0];

          getSelectedStakeholderDetails(
            setCommonMappedStakeholderList,
            firstRow.sourceGrowerLandId,
            (((details.RescChooseStakeholder === 'Grower') &&
              (details.RescChoosetoStakeholder === 'LLE')) ||
              ((details.RescChooseStakeholder === 'Grower') &&
                (details.RescChoosetoStakeholder === 'InterimStorageOperator')) ||
              ((details.RescChooseStakeholder === 'Grower') &&
                (details.RescChoosetoStakeholder === 'Plant')))
              ? firstRow.urn
              : "",
            details.RescChoosetoStakeholder,
            ((details.RescChooseStakeholder === 'LLE') &&
              (details.RescChoosetoStakeholder === 'InterimStorageOperator'))
              ? firstRow.urn
              : '',
            firstRow?.growerType
          );
        }
      }
      else {
        setshowData(true)
        setStakeHolderDetails(false)
      }
    }
  }, [mappedToBeStakeholder]);


  useEffect(() => {
    if (mappingValidationCheck.length > 0) {
      const failTempArr = [];
      const successTempArr = [];
      mappingValidationCheck?.map((item) => {
        if (item?.validationStatus?.status === "FAILURE") {
          if (item?.mapping?.sourceStakeholderType === 'Grower') {
            const pushObject = showArrGrower.find(findItem => ((findItem?.urn === item?.mapping?.sourceStakeholderUrn) && (findItem?.sourceGrowerLandId === item?.mapping?.sourceGrowerLandId)));
            failTempArr.push(pushObject);
          }
          else {
            const pushObject = showArrGrower.find(findItem => ((findItem?.urn === item?.mapping?.sourceStakeholderUrn)));
            failTempArr.push(pushObject);
          }
        }
        if (mappingValidationCheck?.every(item => item?.validationStatus?.status === "SUCCESS")) {
          // const pushObject = showArrGrower.find(findItem => findItem?.urn === item?.mapping?.sourceStakeholderUrn);
          if (item?.mapping?.sourceStakeholderType === 'Grower') {
            const pushObject = showArrGrower.find(findItem => ((findItem?.urn === item?.mapping?.sourceStakeholderUrn) && (findItem?.sourceGrowerLandId === item?.mapping?.sourceGrowerLandId)));
            successTempArr.push(pushObject);
          }
          else {
            const pushObject = showArrGrower.find(findItem => ((findItem?.urn === item?.mapping?.sourceStakeholderUrn)));
            successTempArr.push(pushObject);
          }
        }
      });
      setSuccessMappingArr(successTempArr)
      setFailedMappingArr(failTempArr);
      // if (!mappingValidationCheck?.every(item => item?.validationStatus?.status === "SUCCESS")) {
      //   toast.error("Mappings Marked In Red Are Pending For Approval")
      // }
    }
  }, [showArrGrower, mappingValidationCheck, finaldata]);
  useEffect(() => {

    if (successMappingArr?.length > 0 && mappingValidationCheck) {
      handleValidationModalClose()
      saveStakeHolderMapping(finaldata, setSaveMappingData)
      setSuccessMappingArr()
      setMappingValidationCheck([])
    }
  }, [setSaveMappingData, successMappingArr, mappingValidationCheck, finaldata]);
  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value })
    setStakeHolderDetails(false)
    setshowData(false)
    setSaveMultiMappingData([])
    if (e.target.name === "resourceState") {
      getAllDistrict(setchooseDistrict, e.target.value)
      setErrorMessage({ ...errorMessage, stateError: "" });
    }
    if (e.target.name === "resourceDistrict") {
      setErrorMessage({ ...errorMessage, districtError: "" });
    }
    if (e.target.name === "RescChoosetoStakeholder") {
      setDetails({ ...details, [e.target.name]: e.target.value })
      setErrorMessage({ ...errorMessage, chooseTostakeholderError: "" });
    }
    if (e.target.name === "RescChooseStakeholder") {
      setDetails({ ...details, RescChooseStakeholder: '', RescChoosetoStakeholder: '' })
      if (e.target.value !== 'Select Stakeholder') {
        gettoStakeholderType(setchooseFromUser, e.target.value)
        setErrorMessage({ ...errorMessage, choosestakeholderError: "" })
      }
      else {
        setErrorMessage({ ...errorMessage, choosestakeholderError: "Choose From Stakeholder" });
      }
      e.target.value === 'Grower' ? setShowStateDistrictInput(true) : setShowStateDistrictInput(false)
      if ((e.target.value === 'Grower') && (details.resourceState)) { setDetails({ ...details, resourceState: '', resourceDistrict: '' }) }
      if ((e.target.value !== 'Grower') && (details.resourceState)) {
        setDetails({ ...details, resourceState: '', resourceDistrict: '' })
      }
      if ((e.target.value !== 'Grower') && chooseDistrict) {
        setchooseDistrict([])
      }
      if ((e.target.value !== 'Grower') && (updatedDetails.growerUrn)) { setUpdatedDetails({ ...updatedDetails, growerUrn: '' }) }
      setDetails({ ...details, RescChooseStakeholder: e.target.value, RescChoosetoStakeholder: '' })
    }

  }
  const onSubmitStakeholder = (e) => {
    e.preventDefault();
    setValidationlogOpen(false)
    setMappingValidationCheck([])
    setshowLLEName(false)
    if (details.RescChooseStakeholder === 'Grower') {
      if ((details.RescChooseStakeholder.length > 1) && (details.resourceDistrict) && (details.resourceState) && (details.RescChoosetoStakeholder.length > 0)) {
        setSubmit(false)
        getAllStakeHolderDetails(setMappedToBeStakeholder, details);
      }
      else {
        setSubmit(true)
        if (!details.resourceDistrict) {
          setErrorMessage({ ...errorMessage, districtError: "Select District" });
        }
        if (!details.resourceState) {
          setErrorMessage({ ...errorMessage, stateError: "Select State" });
        }

        if (details.RescChoosetoStakeholder.length < 2) {
          setErrorMessage({ ...errorMessage, chooseTostakeholderError: "Choose To Stakeholder" });
        }
        if (details.RescChooseStakeholder.length < 2) {
          setErrorMessage({ ...errorMessage, choosestakeholderError: "Choose From Stakeholder" });
        }
      }
    }
    else {
      if ((details.RescChooseStakeholder.length > 1) && (details.RescChoosetoStakeholder.length > 0)) {
        setSubmit(false)
        setErrorMessage({ ...errorMessage, stateError: " ", districtError: " " });
        getAllStakeHolderDetails(setMappedToBeStakeholder, details);
      }
      else {
        setSubmit(true)
        if (details.RescChoosetoStakeholder.length < 1) {
          setErrorMessage({ ...errorMessage, chooseTostakeholderError: "Choose To Stakeholder" });
        }
        if (details.RescChooseStakeholder.length < 2) {
          setErrorMessage({ ...errorMessage, choosestakeholderError: "Choose From Stakeholder" });
        }
      }

    }
  }

  const onSelect = (e, mappeditem) => {
    e.preventDefault();

    setUpdatedDetails({
      ...updatedDetails,
      mappedItemId: mappeditem.sourceGrowerLandId ? mappeditem.sourceGrowerLandId : mappeditem.sourceId,
      growerUrn: mappeditem.sourceUrn,
      growerType: mappeditem.growerType
    })

    if (details.RescChoosetoStakeholder === 'Plant') {
      // saveMultiMappingData.push({
      //   "sourceStakeholderType": details.RescChooseStakeholder,
      //   "growerType": mappeditem?.growerType,
      //   "transporterUrn": "",
      //   "sourceStakeholderUrn": mappeditem?.urn,
      //   "targetStakeholderType": details?.RescChoosetoStakeholder,
      //   "targetStakeholderUrn": PLANT_URN,
      //   "sourceGrowerLandId": mappeditem?.sourceGrowerLandId,
      //   "distance": null,
      //   "mappedItemId": mappeditem.sourceGrowerLandId ? mappeditem.sourceGrowerLandId : mappeditem.sourceId,
      //   "mappedStakeholderName": "Assam Bio Ethanol Private Limited"

      // })
      getSelectedStakeholderDetails(setSelectedStakeHolderDetails, mappeditem.sourceGrowerLandId, ((details.RescChooseStakeholder === 'Grower') && (details.RescChoosetoStakeholder === 'Plant')) ? mappeditem.urn : "", details.RescChoosetoStakeholder, '', mappeditem?.growerType)
      setshowLLEName(true)
    }
    else {
      setshowLLEName(true)
      getSelectedStakeholderDetails(setSelectedStakeHolderDetails, mappeditem.sourceGrowerLandId, (((details.RescChooseStakeholder === 'Grower') && (details.RescChoosetoStakeholder === 'LLE')) || ((details.RescChooseStakeholder === 'Grower') && (details.RescChoosetoStakeholder === 'InterimStorageOperator'))) ? mappeditem.urn : "", details.RescChoosetoStakeholder, ((details.RescChooseStakeholder === 'LLE') && (details.RescChoosetoStakeholder === 'InterimStorageOperator')) ? mappeditem.urn : '', mappeditem?.growerType)
    }

  }
  const onMultiSaveMapping = (e) => {
    e.preventDefault();
    handleConfirmLogModalOpenSave();
  }
  function onConfirmCallBackSave() {
    handleConfirmLogModalCloseSave();
    const requestData = saveMultiMappingData?.map((({ mappedItemId, mappedStakeholderName, ...rest }) => rest))
    //saveStakeHolderMapping(requestData, setSaveMappingData)
    setFinalData(requestData)
    validation_check_mapping(requestData, setMappingValidationCheck, true)
  }
  function onCancelBackSave() {
    handleConfirmLogModalCloseSave();
  }
  const viewSaveMapping = (e, mappeditem) => {
    setUpdatedDetails({ ...updatedDetails, mappedItemId: mappeditem.sourceGrowerLandId, growerUrn: mappeditem.urn })
    if (details.RescChoosetoStakeholder === 'LLE') {
      setLinkedtoArray(['Plant', 'InterimStorageOperator'])
    }
    else if (details.RescChoosetoStakeholder === 'Plant') { setLinkedtoArray(['LLE', 'InterimStorageOperator']) }
    else { setLinkedtoArray(['LLE', 'Plant']) }

    handleMappedModalOpen();
  }
  const onCancelMapping = (e, item) => {
    e.preventDefault();
    setMappingValidationCheck([])
    setFailedMappingArr()
    let filteredArray = item?.sourceId ? saveMultiMappingData?.filter(function (itm) {
      return item?.sourceId.indexOf(itm?.mappedItemId) < 0;
    })
      :
      saveMultiMappingData?.filter(function (itm) {
        return item?.sourceGrowerLandId.indexOf(itm?.mappedItemId) < 0;
      })
    setSaveMultiMappingData(filteredArray)
    const rowId = item?.sourceId ? item?.sourceId : item?.sourceGrowerLandId;

    setSelectionModel(prev =>
      prev.filter(id => id !== rowId)
    );

    setSelectedMappingRows(prev =>
      prev.filter(row =>
        getMappedItemId(row) !== rowId
      )
    );
    setshowLLEName(false)
  }
  const onUpadtedTargetDetails = (e, mappeditem) => {
    e.preventDefault();
    let result_mappeddetails = e.target.value.split("*")
    // console.log("result_mappeddetails", result_mappeddetails)
    // console.log("mappeditem", mappeditem)
    // console.log("e.target", e.target.value)
    const tempObj = {
      "sourceStakeholderType": details.RescChooseStakeholder,
      "growerType": mappeditem?.growerType,
      "transporterUrn": "",
      "sourceStakeholderUrn": mappeditem?.urn,
      "sourceStakeholderName": mappeditem?.name,
      "targetStakeholderType": details?.RescChoosetoStakeholder,
      "targetStakeholderUrn": result_mappeddetails[1],
      "targetStakeholderName": result_mappeddetails[0],
      "sourceGrowerLandId": mappeditem?.sourceGrowerLandId,
      "distance": result_mappeddetails[2],
      "bambooQuantity": mappeditem?.qtybamboo,
      "mappedItemId": mappeditem.sourceGrowerLandId ? mappeditem.sourceGrowerLandId : mappeditem.sourceId,
      "mappedStakeholderName": result_mappeddetails[0],
      "landName": mappeditem?.landname,
      "targetState": result_mappeddetails[3],
      "targetDistrict": result_mappeddetails[4],
      "storageLocation": result_mappeddetails[5]
    }
    const { mappedItemId, mappedStakeholderName, ...rest } = tempObj
    validation_check_mapping([{ ...rest }], setMappingValidationCheck, false).then(result => {
      if (result) {
        saveMultiMappingData.push(tempObj)
        setshowLLEName(false)
        setUpdatedDetails({ ...updatedDetails, UpdatedTargetName: result_mappeddetails[0], UpdatedTargetUrn: result_mappeddetails[1], inBetweenDistance: result_mappeddetails[2] })
      }
      else toast.error("Mapping already exists")
    });
  }

  const onDeactiveMapped = (e, mappeditem) => {
    e.preventDefault();
    if (mappeditem.isActive === 'N') {
      setUpdatedDetails({ ...updatedDetails, UpdatedTargetUrn: mappeditem?.targetStakeholderUrn, deactiveid: mappeditem?.sourceGrowerTableId, growerUrn: mappeditem?.urn, deactivestatus: "N", sourceGrowerLandId: details.RescChooseStakeholder === "Grower" ? mappeditem?.sourceGrowerLandId : null })
    }
    else {
      setUpdatedDetails({ ...updatedDetails, UpdatedTargetUrn: mappeditem?.targetStakeholderUrn, deactiveid: mappeditem?.sourceGrowerTableId, growerUrn: mappeditem?.urn, deactivestatus: "Y", sourceGrowerLandId: details.RescChooseStakeholder === "Grower" ? mappeditem?.sourceGrowerLandId : null })
    }
    const data = {
      "sourceStakeholderType": details.RescChooseStakeholder,
      "targetStakeholderType": details.RescChoosetoStakeholder,
      "sourceStakeholderUrn": mappeditem?.urn,
      "growerType": mappeditem?.growerType,
      "targetStakeholderUrn": mappeditem?.targetStakeholderUrn,
      "transporterUrn": "",
      "transporterName": "",
      "route": "",
      "sourceGrowerLandId": mappeditem?.sourceGrowerLandId,
      "operation": (mappeditem.isActive === "Y") ? "Deactivate" : "Activate",
    }
    checkMappingExists(data, handleConfirmLogModalOpen, setMessage);
    // handleConfirmLogModalOpen();
  };
  const onDeleteMappedTransporter = (e, mappeditem) => {
    e.preventDefault();
    setUpdatedDetails({ ...updatedDetails, UpdatedTargetUrn: mappeditem?.targetStakeholderUrn, deleteid: mappeditem?.sourceGrowerTableId, growerUrn: mappeditem?.urn, deactivestatus: "N", sourceGrowerLandId: details.RescChooseStakeholder === "Grower" ? mappeditem?.sourceGrowerLandId : null })
    const data = {
      "sourceStakeholderType": details.RescChooseStakeholder,
      "growerType": mappeditem?.growerType,
      "targetStakeholderType": details.RescChoosetoStakeholder,
      "sourceStakeholderUrn": mappeditem?.urn,
      "targetStakeholderUrn": mappeditem?.targetStakeholderUrn,
      "targetStakeholderName": mappeditem?.targetStakeholderName,
      "transporterUrn": "",
      "transporterName": "",
      "route": "",
      "sourceGrowerLandId": mappeditem?.sourceGrowerLandId,
      "operation": "Delete",
    }
    checkMappingExists(data, handleConfirmLogModalOpen, setMessage);
    // handleConfirmLogModalOpen();
  };

  function onConfirmCallBack() {
    handleConfirmLogModalClose();
    if ((updatedDetails.deactiveid) || (updatedDetails.deleteid)) {
      DeleteDeactiveEditTransporterMapping(updatedDetails, details, setSaveMappingData)
    }
  }
  function onCancelBack() {
    handleConfirmLogModalClose();

    setUpdatedDetails('');
  }

  const getMappedItemId = (row) => row?.sourceGrowerLandId ? row?.sourceGrowerLandId : row?.sourceId;

  const handleCommonRowSelection = (newSelectionModel) => {
    const selectedRows = showArrGrower.filter(row =>
      newSelectionModel.includes(getMappedItemId(row))
    );

    setSelectedMappingRows(selectedRows);
  };

  const mappingcol = [
    {
      field: 'name', width: 220,
      renderHeader: () => (
        <strong>
          {details?.RescChooseStakeholder} Name
        </strong>
      ),
      renderCell: (params) => (
        <Typography>{params?.row?.name && titleCase(params?.row?.name)}</Typography>
      )
    },
    {
      field: 'urn', width: 150, sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
      renderHeader: () => (
        <strong>{details?.RescChooseStakeholder} URN</strong>
      ),
    },
    {
      field: 'landname', headerName: 'Land Name', width: 150, hide: (details?.RescChooseStakeholder !== 'Grower') && true,
      renderCell: (params) => (
        <Typography>{params?.row?.landname && titleCase(params?.row?.landname)}</Typography>
      )
    },
    {
      field: 'qtybamboo', headerName: 'Bamboo qty(in MT)', width: 150, hide: !((details.RescChooseStakeholder === 'Grower') && (details.RescChoosetoStakeholder === 'LLE')) && true,
    },
    {
      field: 'distance', headerName: 'Distance(in KM)', width: 150, hide: !(((details.RescChooseStakeholder === 'Grower') && (details.RescChoosetoStakeholder === 'Plant')) || ((details.RescChooseStakeholder === 'Grower') && (details.RescChoosetoStakeholder === 'LLE')) || ((details.RescChooseStakeholder === 'Grower') && (details.RescChoosetoStakeholder === 'InterimStorageOperator')) || ((details.RescChooseStakeholder === 'LLE') && (details.RescChoosetoStakeholder === 'InterimStorageOperator'))) && true,
      valueGetter: (params) => {
        return (
          saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
            ?
            saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
              <Typography>{item?.distance ? item?.distance : ""}</Typography>
            ))
            : < Typography > {params?.row?.distance && ParseFloat(params?.row?.distance)}</Typography >
        )
      },
      renderCell: (params) => {
        return (
          saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
            ?
            saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
              <Typography>{item?.distance ? item?.distance : ""}</Typography>
            ))
            : < Typography > {params?.row?.distance && ParseFloat(params?.row?.distance)}</Typography >
        )
      }
    },
    {
      field: 'mapped', headerName: 'mapped check', width: 180, hide: true
    },
    {
      field: 'toname', width: 260,
      renderHeader: () => (
        <strong>
          {details.RescChoosetoStakeholder} Name
        </strong>
      ),
      valueGetter: (params) => {
        return (details?.RescChooseStakeholder === 'Grower') ?
          showLLEName && (updatedDetails?.mappedItemId === params?.row?.sourceGrowerLandId) ?
            updatedDetails.UpdatedTargetName
            :
            saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
              ?
              saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
                item.mappedStakeholderName ? item.mappedStakeholderName : NOT_MAPPED
              ))
              :
              params?.row?.targetStakeholderName ? params?.row?.targetStakeholderName : NOT_MAPPED
          :
          showLLEName && (updatedDetails.mappedItemId === params?.row?.sourceId) ?
            updatedDetails.UpdatedTargetName
            :
            saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
              ?
              saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
                item?.mappedStakeholderName ? item?.mappedStakeholderName : NOT_MAPPED
              ))
              :
              params?.row?.targetStakeholderName ? params?.row?.targetStakeholderName : NOT_MAPPED
      },
      renderCell: (params) => (
        (details?.RescChooseStakeholder === 'Grower') ?
          showLLEName && (updatedDetails?.mappedItemId === params?.row?.sourceGrowerLandId) ?
            <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
              <InputLabel id="mapfrom-label">{details?.RescChoosetoStakeholder}</InputLabel>
              <Select
                label={details?.RescChoosetoStakeholder}
                name="UpdatedTargetName" onChange={(e) => onUpadtedTargetDetails(e, params?.row)}
                size='small'
                sx={{ width: '100%', padding: "3%" }}>
                <MenuItem><em>Select Stakeholder</em></MenuItem>
                {
                  selectedStakeHolderDetails.map((maapedtoname) =>
                    <MenuItem value={maapedtoname?.stakeholderName + '*' + maapedtoname?.urn + '*' + maapedtoname?.distance + '*' + maapedtoname?.state + '*' + maapedtoname?.district}>{maapedtoname?.stakeholderName}({maapedtoname?.urn}) {(maapedtoname?.distance) ? (',' + ParseFloat(maapedtoname?.distance)) : null}</MenuItem>)
                }
              </Select>
            </FormControl>
            :
            saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
              ?
              saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
                <Typography>{item.mappedStakeholderName ? item.mappedStakeholderName : NOT_MAPPED}</Typography>
              ))
              :
              <Typography>{params?.row?.targetStakeholderName ? params?.row?.targetStakeholderName : NOT_MAPPED}</Typography>
          :
          showLLEName && (updatedDetails.mappedItemId === params?.row?.sourceId) ?
            <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
              <InputLabel id="mapfrom-label">{details?.RescChoosetoStakeholder}</InputLabel>
              <Select
                label={details?.RescChoosetoStakeholder}
                name="UpdatedTargetName" onChange={(e) => onUpadtedTargetDetails(e, params?.row)}
                size='small'
                sx={{ width: '100%', padding: "3%" }}>
                <MenuItem><em>Select Stakeholder</em></MenuItem>
                {
                  selectedStakeHolderDetails.map((maapedtoname) =>
                    <MenuItem value={maapedtoname?.stakeholderName + '*' + maapedtoname?.urn + '*' + maapedtoname?.distance}>{maapedtoname?.stakeholderName}({maapedtoname?.urn}) {(maapedtoname?.distance) ? (',' + ParseFloat(maapedtoname?.distance)) : null}</MenuItem>)
                }
              </Select>
            </FormControl>
            :
            saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
              ?
              saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
                <Typography>{item?.mappedStakeholderName ? item?.mappedStakeholderName : NOT_MAPPED}</Typography>
              ))
              :
              <Typography>{params?.row?.targetStakeholderName ? params?.row?.targetStakeholderName : NOT_MAPPED}</Typography>
      )
    },
    {
      field: 'tourn', width: 220,
      renderHeader: () => (
        <strong>
          {details.RescChoosetoStakeholder} URN
        </strong>
      ),
      valueGetter: (params) => {
        return (details?.RescChooseStakeholder === 'Grower') ?
          showLLEName && (updatedDetails?.mappedItemId === params?.row?.sourceGrowerLandId) ?
            NOT_MAPPED
            :
            saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
              ?
              saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
                item?.targetStakeholderUrn ? item?.targetStakeholderUrn : NOT_MAPPED
              ))
              :
              params?.row?.targetStakeholderUrn ? params?.row?.targetStakeholderUrn : NOT_MAPPED
          :
          showLLEName && (updatedDetails.mappedItemId === params?.row?.sourceId) ?
            NOT_MAPPED
            :
            saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
              ?
              saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
                item?.targetStakeholderUrn ? item?.targetStakeholderUrn : NOT_MAPPED
              ))
              :
              params?.row?.targetStakeholderUrn ? params?.row?.targetStakeholderUrn : NOT_MAPPED
      },
      renderCell: (params) => (
        (details?.RescChooseStakeholder === 'Grower') ?
          showLLEName && (updatedDetails?.mappedItemId === params?.row?.sourceGrowerLandId) ?
            <Typography>{NOT_MAPPED}</Typography>
            :
            saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
              ?
              saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
                <Typography>{item?.targetStakeholderUrn ? item?.targetStakeholderUrn : NOT_MAPPED}</Typography>
              ))
              :
              <Typography>{params?.row?.targetStakeholderUrn ? params?.row?.targetStakeholderUrn : NOT_MAPPED}</Typography>
          :
          showLLEName && (updatedDetails.mappedItemId === params?.row?.sourceId) ?
            <Typography>{NOT_MAPPED}</Typography>
            :
            saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
              ?
              saveMultiMappingData?.filter(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId))).map(item => (
                <Typography>{item?.targetStakeholderUrn ? item?.targetStakeholderUrn : NOT_MAPPED}</Typography>
              ))
              :
              <Typography>{params?.row?.targetStakeholderUrn ? params?.row?.targetStakeholderUrn : NOT_MAPPED}</Typography>
      )
    },
    {
      field: 'viewmapping', headerName: 'OtherStakeholder Mappings', width: 200, hide: (details.RescChooseStakeholder !== 'Grower') && true,
      renderCell: (params) => (
        <Tooltip title="View"><IconButton color="primary" sx={{ minWidth: 70, ml: 5 }} variant="contained" onClick={(e) => viewSaveMapping(e, params?.row)} ><RemoveRedEyeIcon /></IconButton></Tooltip>
      )
    },
    {
      field: 'action', headerName: 'Action', width: 100,
      // valueGetter: (params) => {
      //   return params?.row?.mapped === true ?
      //     MAPPED
      //     :
      //     saveMultiMappingData.length < 1 ?
      //       "Add"
      //       :
      //       saveMultiMappingData.find(item => ((item?.mappedItemId === params?.row?.sourceId) || (item?.mappedItemId === params?.row?.sourceGrowerLandId)))
      //         ?
      //         "Cancel"
      //         :
      //         "Add"

      // },
      renderCell: (params) => (
        params?.row?.mapped === true ?
          <Typography>{MAPPED}</Typography>
          :
          saveMultiMappingData.find(item =>
            item?.mappedItemId === params?.row?.sourceId ||
            item?.mappedItemId === params?.row?.sourceGrowerLandId
          )
            ?
            <Button sx={{ minWidth: 70 }} variant="contained" onClick={(e) => onCancelMapping(e, params?.row)}>
              Cancel
            </Button>
            :
            <Typography>{NOT_MAPPED}</Typography>
      )
    },
    {
      field: 'activeaction', headerName: 'Activated/Deactivated', width: 180,
      valueGetter: (params) => {
        return params?.row?.mapped === true ?
          params?.row?.isActive === 'N' ? "Deactivated" : "Activated"
          :
          NOT_MAPPED
      },
      renderCell: (params) => (
        (params?.row?.mapped === true) ?
          <MDBSwitch disabled={params?.row?.isDeleteDeactivate === "Y"} checked={params?.row?.isActive === 'N' ? false : true} className='RescDeactiveSwitch' onClick={(e) => onDeactiveMapped(e, params?.row)} id='flexSwitchCheckChecked' />
          :
          <Typography>{NOT_MAPPED}</Typography>
      )
    },
    {
      field: 'deleteaction', headerName: 'Delete', width: 100,
      valueGetter: (params) => {
        return params?.row?.mapped === true ?
          "Delete"
          :
          NOT_MAPPED
      },
      renderCell: (params) => (
        (params?.row?.mapped === true) ?
          <IconButton disabled={params?.row?.isDeleteDeactivate === "Y"}
            onClick={(e) => onDeleteMappedTransporter(e, params?.row)}
          >
            <DeleteIcon color={params?.row?.isDeleteDeactivate === "Y" ? 'disabled' : 'error'} fontSize='inherit' />
          </IconButton>
          :
          <Typography>{NOT_MAPPED}</Typography>
      )
    }
  ]

  const onCommonStakeholderChange = (e) => {
    const value = e.target.value;
    if (!value) {
      setCommonMappedStakeholder(value);
      applyCommonMapping(selectedMappingRows, value);
      return;
    }

    const result_mappeddetails = value.split("*");
    const selectedUrn = result_mappeddetails[1];

    const selectedTarget = commonMappedStakeholderList?.find(
      (item) => item.urn === selectedUrn
    );

    if (
      details.RescChooseStakeholder === 'Grower' &&
      (details.RescChoosetoStakeholder === 'LLE' || details.RescChoosetoStakeholder === 'Plant')
    ) {
      if (!selectedTarget?.storageLocation) {
        toast.error(`Mapping is not allowed as selected LLE (${selectedUrn}) was not tagged with any storage location code.`);
        return; 
      }
    }

    setCommonMappedStakeholder(value);
    applyCommonMapping(selectedMappingRows, value);
  };

  const applyCommonMapping = (rows, dropdownValue) => {

    if (!dropdownValue || rows.length === 0) return;

    const result_mappeddetails = dropdownValue.split("*");
    const newMappings = rows.map((mappeditem) => ({
      sourceStakeholderType: details.RescChooseStakeholder,
      growerType: mappeditem?.growerType,
      transporterUrn: "",
      sourceStakeholderUrn: mappeditem?.urn,
      sourceStakeholderName: mappeditem?.name,
      targetStakeholderType: details?.RescChoosetoStakeholder,
      targetStakeholderUrn: result_mappeddetails[1],
      targetStakeholderName: result_mappeddetails[0],
      sourceGrowerLandId: mappeditem?.sourceGrowerLandId,
      distance: result_mappeddetails[2],
      bambooQuantity: mappeditem?.qtybamboo,
      mappedItemId: getMappedItemId(mappeditem),
      mappedStakeholderName: result_mappeddetails[0],
      landName: mappeditem?.landname,
      targetState: result_mappeddetails[3],
      targetDistrict: result_mappeddetails[4],
      storageLocation: result_mappeddetails[5]
    }));

    setSaveMultiMappingData(prev => {

      // remove existing mappings of same rows
      const filteredPrev = prev.filter(
        oldItem =>
          !newMappings.some(
            newItem => newItem.mappedItemId === oldItem.mappedItemId
          )
      );

      return [...filteredPrev, ...newMappings];
    });

    setUpdatedDetails({
      ...updatedDetails,
      UpdatedTargetName: result_mappeddetails[0],
      UpdatedTargetUrn: result_mappeddetails[1],
      inBetweenDistance: result_mappeddetails[2]
    });
  };

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className='pageNumberingResc'>RES01</p>}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h5" gutterBottom>
            Select Stakeholder Mapping
          </Typography>
        </Stack>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={2}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.RescChooseStakeholder}>
                  <InputLabel id="mapfrom-label">Map From</InputLabel>
                  <Select
                    label="Map From"
                    name="RescChooseStakeholder"
                    value={details?.RescChooseStakeholder || ''}
                    onChange={(e) => handleChange(e)}>
                    <MenuItem><em>Select Stakeholder</em></MenuItem>
                    {
                      chooseUser?.map((x) =>
                        <MenuItem value={x}>{x}</MenuItem>)
                    }
                  </Select>
                  <FormHelperText sx={{ color: 'red' }}>{errorMessage?.choosestakeholderError}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={2}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.RescChoosetoStakeholder}>
                  <InputLabel id="mapto-label">Map To</InputLabel>
                  <Select
                    label="Map To"
                    name="RescChoosetoStakeholder" value={details.RescChoosetoStakeholder} onChange={(e) => handleChange(e)}>
                    <MenuItem><em>Mapped Stakeholder</em></MenuItem>
                    {
                      chooseFromUser?.map((touserdata) =>
                        <MenuItem value={touserdata}>{touserdata}</MenuItem>)
                    }
                  </Select>
                  <FormHelperText sx={{ color: 'red' }}>{errorMessage?.chooseTostakeholderError}</FormHelperText>
                </FormControl>
              </Grid>
              {showStateDistrictInput &&
                <>
                  <Grid item xs={12} lg={2}>
                    <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.resourceState}>
                      <InputLabel id="mapstate-label">State</InputLabel>
                      <Select
                        label='State'
                        name="resourceState" value={details.resourceState || ''} onChange={(e) => handleChange(e)}>
                        <MenuItem><em>State</em></MenuItem>
                        {
                          chooseState?.map((statename) =>
                            <MenuItem value={statename}>{statename}</MenuItem>)
                        }
                      </Select>
                      <FormHelperText>{errorMessage?.stateError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={2}>
                    <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.resourceDistrict}>
                      <InputLabel id="mapdistrict-label">District</InputLabel>
                      <Select
                        label='District'
                        name="resourceDistrict" value={details.resourceDistrict || ''} onChange={(e) => handleChange(e)}>
                        <MenuItem><em>District</em></MenuItem>
                        {
                          chooseDistrict?.map((districtname) =>
                            <MenuItem value={districtname}>{districtname}</MenuItem>)
                        }
                      </Select>
                      <FormHelperText>{errorMessage?.districtError}</FormHelperText>
                    </FormControl>
                  </Grid></>
              }
              <Grid item xs={12} lg={1}>
                <Button endIcon={<ProceedIcon />} sx={{ minWidth: 100 }} className="RescProceed" variant="contained" onClick={(e) => onSubmitStakeholder(e)}>Proceed</Button>
              </Grid>

            </Grid>
            {showStakeHolderDetails && showArrGrower ?
              <Grid container spacing={1} sx={{ mt: 3 }}>
                {showStakeHolderDetails && (
                  <Grid item xs={12} lg={4}>
                    <FormControl sx={{ width: '100%' }}>
                      <InputLabel>{details?.RescChoosetoStakeholder}</InputLabel>
                      <Select
                        label={details?.RescChoosetoStakeholder}
                        value={commonMappedStakeholder}
                        onChange={onCommonStakeholderChange}
                      >
                        <MenuItem value="">
                          <em>Select Stakeholder</em>
                        </MenuItem>
                        {commonMappedStakeholderList?.map((mappedToName) => (
                          <MenuItem
                            key={mappedToName?.urn}
                            value={
                              mappedToName?.stakeholderName + '*' +
                              mappedToName?.urn + '*' +
                              mappedToName?.distance + '*' +
                              mappedToName?.state + '*' +
                              mappedToName?.district  + '*' + 
                              mappedToName?.storageLocation
                            }
                          >
                            {mappedToName?.stakeholderName} ({mappedToName?.urn})
                            {mappedToName?.distance ? `, ${ParseFloat(mappedToName?.distance)}` : null}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                <Grid item xs={12} lg={12}>
                  <Box sx={{
                    height: 430, width: '100%', mt: 2,
                    '& .themeSuccess': {
                      backgroundColor: '#FFFFFF'
                    },
                    '& .themeFailure': {
                      backgroundColor: '#FF7F7F',
                      color: '#1a3e72',
                    },
                  }}>
                    <DataGrid
                      rows={showArrGrower}
                      columns={mappingcol}
                      pageSize={5}
                      rowsPerPageOptions={[5]}
                      checkboxSelection
                      disableSelectionOnClick
                      isRowSelectable={(params) => params?.row?.mapped !== true}
                      selectionModel={selectionModel}
                      onSelectionModelChange={(newSelection) => {
                        const removedIds = selectionModel.filter(
                          id => !newSelection.includes(id)
                        );
                        if (removedIds.length > 0) {
                          setSaveMultiMappingData(prev =>
                            prev.filter(
                              item => !removedIds.includes(item.mappedItemId)
                            )
                          );
                        }
                        const selectedRows = showArrGrower.filter(row =>
                          newSelection.includes(getMappedItemId(row))
                        );

                        setSelectionModel(newSelection);
                        setSelectedMappingRows(selectedRows);
                        if (commonMappedStakeholder) {
                          applyCommonMapping(selectedRows, commonMappedStakeholder);
                        }
                      }}

                      getRowId={(row) => row?.sourceGrowerLandId ? row?.sourceGrowerLandId : row?.sourceId}
                      initialState={{
                        sorting: {
                          sortModel: [{ field: 'mapped', sort: "asc" }],
                        },
                      }}
                      getCellClassName={(params) => {
                        return failedMappingArr?.includes(params?.row) ? 'themeFailure' : 'themeSuccess';
                      }}
                      components={{
                        Toolbar: CustomDataGridToolbar,
                      }}
                      componentsProps={{
                        toolbar: {
                          rows: showArrGrower,
                          columns: showArrGrower,
                          fileName: "MappingList.xlsx",
                        }
                      }}
                    />
                  </Box>
                </Grid>
                {saveMultiMappingData?.length > 0 ?
                  <Grid item xs={12} lg={12} display="flex" justifyContent="flex-end">
                    <Button sx={{ minWidth: 100, mt: 3 }} variant="contained" onClick={(e) => onMultiSaveMapping(e)}>Submit</Button>
                  </Grid>
                  : <></>}
              </Grid>
              : showData ?
                <Typography display='flex' alignItems="center" justifyContent="center" sx={{ fontWeight: "bold" }}>{NO_DATA_AVAILABLE}</Typography>
                : null
            }
          </CardContent>
        </Card>
      </Container>
      <Dialog maxWidth='md' fullWidth open={mappedModalOpen}>
        <DialogContent>
          <ViewOtherMappedStakeholder growerLandId={updatedDetails.mappedItemId} urn={updatedDetails.growerUrn} linkedto={linkedtoArray} handleMappedModalClose={handleMappedModalClose} />
        </DialogContent>
      </Dialog>
      <ConfirmationPopover onOpen={logConfirmModalOpen} specialMessage={message} onConfirm={onConfirmCallBack} onClose={onCancelBack} action={(updatedDetails.deactivestatus === "Y") ? "Deactive" : updatedDetails.deleteid ? "Delete" : "Active"} />
      <ConfirmationPopover onOpen={logConfirmModalOpenSave} onConfirm={onConfirmCallBackSave} onClose={onCancelBackSave} action="Submit" />
    </>
  );
}
export default SelectStakeholder;
